import {URL_BASE} from "../../../../../../../../Globals.ts";
import {getIdToken} from "../../../../../../../misc/miscUtils.ts";

export const executeServerToolCall = async (finishedToolCall: any, settingsObjRef: any, userObjRef: any, needsAuth: boolean) => {
    let results = {};
    const isTemp = settingsObjRef.current.isIncognito || !userObjRef.current.user;

    const url = `${URL_BASE}/api/functionCall`;

    const headers: any = {
        "Content-Type": "application/json"
    }
    if (needsAuth) {
        if (!userObjRef.current.user) return {};
        const token = await getIdToken(userObjRef.current.user);

        headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ name: finishedToolCall.name, args: finishedToolCall.args, isTemp: isTemp })
    });

    if (response.ok) results = await response.json();
    else console.error(`Failed to get tool call response: ${response.statusText}`);

    return results;
}
